<div class="login-content">
  <div class="block-left">
    @if (theme?.properties?.loginBackgroundVideoUrl) {
      <video 
        autoplay="autoplay" 
        loop preload="auto" 
        [poster]="backgroundImage || ''" 
        [muted]="'muted'" class="bg_video" 
        style="background-image: url('{{ backgroundImage }}');"
      >
        <source [src]="theme?.properties?.loginBackgroundVideoUrl" type="video/mp4">
      </video>
    } @else {
      <div class="carousel-container">
        <div class="carousel-images">
          <img
            *ngFor="let image of images; let i = index"
            [src]="image"
            [class.active]="i === currentImageIndex"
            alt="Carousel Image"
          />
        </div>
      </div>
      <div class="carousel-dots">
        @for (image of images; track image; let i = $index) {
          <button
            [class.active]="i === currentImageIndex"
            (click)="setImage(i)"
          >&nbsp;</button>
        }
      </div>
    }
  </div>

  @if (showLogin) {
    <div class="block-right" >
      <form [formGroup]="form">
        <img class="logo" [src]="logo()" alt="Logo" />
        <h2>Entrar</h2>
        <div class="container-input" [ngClass]="{ focused: usernameFocused }" style="margin-top: 20px;">
          <label for="username" style="color: var(--primary);">Usuário</label>
          <i
            class="material-icons notranslate left-icon"
          >person_outline</i>
          <input
            formControlName="username"
            type="text"
            name="username"
            placeholder="Usuário"
            (focus)="onFocus('username')"
            (blur)="onBlur('username')"
          />
        </div>
        <div class="container-input" [ngClass]="{ focused: passwordFocused }">
          <label for="currentPassword">Senha</label>
          <i
            class="material-icons notranslate left-icon"
          >
            {{ passwordFocused ? 'lock_open' : 'lock_outline' }}
          </i>
          <input
            formControlName="currentPassword"
            [type]="showPassword ? 'text' : 'password'"
            name="currentPassword"
            placeholder="Senha"
            (focus)="onFocus('currentPassword')"
          />
          @if(passwordFocused) {
            <i
              class="material-icons notranslate right-icon"
              (click)="toggleShowPassword()"
            >
              {{ showPassword ? 'visibility_off' : 'visibility' }}
            </i>
          }
        </div>

        <a class="forgot-password" (click)="handleForgetPassword()"
          >Esqueci minha senha</a
        >

        <div class="container-button">
          @if(incorrectPassword){
            <div class="warning">
              <i class="material-icons notranslate v-align"> report_problem </i>
              <span>Usuário ou senha incorretos</span>
            </div>
          }
          <button type="submit" class="button green" (click)="submitForm()">Entrar</button>
        </div>
      </form>
    </div>
  }

  @if(doubleAuthentication) {
    <div class="block-right">
      <form [formGroup]="doubleAuthenticationForm">
        <img class="logo" [src]="logo()" alt="Logo" />
        <h2>Autenticação</h2>
        <div class="container-input" [ngClass]="{ focused: codeFocused }" style="margin-top: 20px;">
          <label for="username">Código</label>
          <i class="material-icons notranslate left-icon">key</i>
          <input
            formControlName="code"
            type="string"
            name="code"
            placeholder="Digite o código recebido via email"
            (focus)="onFocus('code')"
            (blur)="onBlur('code')"
          />
        </div>
        @if (doubleAuthenticationForm.get('code')?.touched && !doubleAuthenticationForm.get('code')?.value) {
          <div class="warning">
            <i class="material-icons notranslate v-align"> report_problem </i>
            <span>{{ 'VALIDATORS.FILL-IN-ALL-FIELDS' | translate }}</span>
          </div>
        }
        @if(!timeExpired) {
          <app-countdown (countdownFinished)="onCountdownFinished()"></app-countdown>
        }
        <div class="container-button">
          <button type="submit" class="button green" (click)="submitDoubleAuthentication()">Enviar</button>
        </div>
      </form>
    </div>
  }

  @if (showForgotPassword) {
    <div class="block-right">
      <form [formGroup]="resetPasswordForm">
        <img class="logo" [src]="logo()" alt="Logo" />
        <h2>Esqueci minha senha</h2>
        <h3>Informe seu e-mail de cadastro para enviarmos o código de redefinição de senha
        </h3>
        <div class="container-input" [ngClass]="{ focused: emailFocused }">
          <label for="email">E-mail</label>
          <i
            class="material-icons notranslate left-icon"
            (click)="toggleShowPassword()"
          >
            mail_outline
          </i>
          <input
            type="email"
            name="email"
            placeholder="Digite seu e-mail"
            formControlName="email"
            (focus)="onFocus('email')"
            (blur)="onBlur('email')"
          />
        </div>
        <div class="container-button">
          @if (resetPasswordForm.get('email')?.touched && resetPasswordForm.get('email')?.invalid) {
            <div class="warning">
              <i class="material-icons notranslate v-align"> report_problem </i>
              <span>E-mail Inválido!</span>
            </div>
          }
          <button type="submit" class="button green" (click)="submitResetPasswordForm()">
            Enviar
          </button>
          <button
            type="button"
            class="button gray"
            (click)="handleClickCloseRegister()"
          >
            Voltar
          </button>
        </div>
      </form>
    </div>
  }

  @if (showChangePassword) {
    <div class="block-right">
      <form [formGroup]="changePasswordForm">
        <img class="logo" [src]="logo()" alt="Logo" />
        <h2>Redefinição de senha</h2>
        <h3>Informe a nova senha</h3>
        <div class="container-input" [ngClass]="{ focused: passwordFocused }">
          <label for="password">Nova senha:</label>
          <i
            class="material-icons notranslate left-icon"
          >
            {{ passwordFocused ? 'lock_open' : 'lock_outline' }}
          </i>
          <input
            formControlName="newPassword"
            [type]="showPassword ? 'text' : 'password'"
            name="newPassword"
            placeholder="Nova senha"
            (focus)="onFocus('newPassword')"
            (blur)="onBlur('newPassword')"
            autocomplete="new-password"
          />
           @if(passwordFocused) {
            <i
              class="material-icons notranslate right-icon"
              (click)="toggleShowPassword()"
            >
              {{ showPassword ? 'visibility_off' : 'visibility' }}
            </i>
          }
        </div>
        <div class="container-input" [ngClass]="{ focused: passwordFocusedConfirm }">
          <label for="confirmNewPassword">Confirme a nova senha:</label>
          <i
            class="material-icons notranslate left-icon"
          >
            {{ passwordFocusedConfirm ? 'lock_open' : 'lock_outline' }}
          </i>
          <input
            formControlName="confirmNewPassword"
            [type]="showPasswordConfirm ? 'text' : 'password'"
            name="confirmNewPassword"
            placeholder="Confirme a nova senha"
            (focus)="onFocus('confirmNewPassword')"
            (blur)="onBlur('confirmNewPassword')"
            autocomplete="new-password"
          />
          @if(passwordFocusedConfirm) {
            <i
              class="material-icons notranslate right-icon"
              (click)="toggleShowPasswordConfirm()"
            >
              {{ showPasswordConfirm ? 'visibility_off' : 'visibility' }}
            </i>
          }
        </div>
        @if (changePasswordForm.get('newPassword')?.touched && !changePasswordForm.get('newPassword')?.value && !changePasswordForm.get('confirmNewPassword')?.value && changePasswordForm.get('confirmNewPassword')?.touched) {
          <div class="warning">
            <i class="material-icons notranslate v-align"> report_problem </i>
            <span> É necessário preencher todos os campos.</span>
          </div>
        }
        @if (changePasswordForm.errors?.['passwordsMismatch']) {
          <div class="warning">
            <i class="material-icons notranslate v-align"> report_problem </i>
            <span> As senhas não coincidem.</span>
          </div>
        }
        @if (changePasswordForm.get('newPassword')?.touched && changePasswordForm.get('newPassword')?.errors?.['passwordStrength']) {
          <div class="warning">
            <i class="material-icons notranslate v-align"> report_problem </i>
            <span>A nova senha deve conter no mínimo 8 caracteres, incluindo pelo menos uma letra maiúscula, um número e um caractere especial.</span>
          </div>
        }
        <div class="container-button">
          <button class="button green" type="submit" (click)="submitChangePasswordForm()">
            Enviar
          </button>
          <button
            type="button"
            class="button gray"
            (click)="handleClickCloseRegister()"
          >
            Voltar
          </button>
        </div>
      </form>
    </div>
  }
</div>
